// extracted by mini-css-extract-plugin
export default {"container":"Du-z","title":"Eu-z","linkContainer":"Fu-z","viewItemLink":"Gu-z"};